// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { editSpecialOffer, getSpecialOfferById } from "../../../features/specialOffers";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";

const EditSpecialOffer = () => {
  const { id } = useParams<{ id: string }>();
  const { specialOffer, status } = useSelector((state: any) => state.specialOffer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "", // Fixed for this offer
    descriptions: [""],
    price: 0,
    photo: null,
  });

  useEffect(() => {
    // Fetch special offer data by ID
    dispatch(getSpecialOfferById(id));
  }, [dispatch, id]);

  useEffect(() => {

    if (status && specialOffer) {
      const data = specialOffer.data;
      setFormData({
        name: data.name ,
        descriptions: data.descriptions ,
        price: data.price ,
        photo: data.photo ,
      });
    }
  }, [status, specialOffer]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDescription = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,index:number) => {
    const {  value } = e.target;
    setFormData((prev) => ({
      ...prev,
      descriptions: prev && prev.descriptions.map((desc, i) =>
        i === index ? value : desc // Update the value at the specific index
      ),
    }));
  };
  const handleThumbnailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0], // Handle thumbnail image change
      }));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key === "descriptions" && Array.isArray(value)) {
        value.forEach((desc, index) => {
          formDataFinal.append(`descriptions`, desc); // Adds descriptions[0], descriptions[1], etc.
        });
      } else if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(editSpecialOffer({ id, updatedOffer: formDataFinal }))
      .then((res: any) => {
        toast.success(res.payload.message); // Assuming you have a toast function
        navigate("/special-offer"); // Redirect to special offers page
      })
      .catch((err: any) => {
        console.error(err, "error");
        toast.error("An error occurred while updating the special offer.");
      });
  };

  const handleAddDescription = () => {
    
    setFormData({
      ...formData,
      descriptions: [...formData.descriptions, ""], // Create a new array with the added description
    });
  }

  const handleRemoveDescription = (id:any) => {
    setFormData({
      ...formData,
      descriptions: formData.descriptions.filter((_,index)=>id !== index), // Create a new array with the added description
    });
  }
  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      {/* Form Container */}
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Edit Special Offer
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Name Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="name"
              placeholder="Enter the offer name"
              value={formData.name}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Description Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Description
              </SoftTypography>
            </SoftBox>
            {
formData &&  formData.descriptions.map((description:any,index:number)=>
<>
<SoftBox display="flex">
  <SoftInput
  style={{ marginTop: '5px' }}
    type="text"
    name="descriptions"
    placeholder="Enter the offer description"
    value={description}
    onChange={(e)=>handleChangeDescription(e,index)}
  />
  {

 index === 0 && <FaCirclePlus style={{ marginLeft: '5px' }} onClick={handleAddDescription}  />
  }

{

index !== 0 && <FaCircleMinus style={{ marginLeft: '5px' }} onClick={()=>handleRemoveDescription(index)}  />
 }
  </SoftBox>
</>
)
            }
          </SoftBox>

          {/* Price Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Price
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="number"
              name="price"
              placeholder="Enter the price"
              value={formData.price}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Thumbnail Image Upload */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Photo
              </SoftTypography>
            </SoftBox>
            {formData.photo && (
              <img
                src={formData.photo.name?URL.createObjectURL(formData.photo):formData.photo} 
                alt="photo"
                style={{ width: "150px", height: "150px", borderRadius: "5px" }}
              />
            )}
            <input
              type="file"
              name="photo"
              onChange={handleThumbnailChange}
              style={{ width: "100%" }}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="info" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditSpecialOffer;
